import { Api } from 'utils';

class HomeService {
  static get = async (params = {}) => Api.createResponse('app/home/', params);

  static admin = {
    getUsers: async (params = {}) =>
      Api.createResponse('admin/home/users', params),
    getProfit: async (params = {}) =>
      Api.createResponse('admin/home/profit', params),
    getDocumentsGenerated: async (params = {}) =>
      Api.createResponse('admin/home/documents-generated', params),
    getMemberships: async (params = {}) =>
      Api.createResponse('admin/home/memberships', params),
  };
}

export default HomeService;
